// FETCH ALL PROPERTIES FROM MENU MASTER
export const FETCH_MENU_MASTER_REQUEST = 'FETCH_MENU_MASTER_REQUEST';
export const FETCH_MENU_MASTER_SUCCESS = 'FETCH_MENU_MASTER_SUCCESS';
export const FETCH_MENU_MASTER_FAILURE = 'FETCH_MENU_MASTER_FAILURE';

// CREATE PROPERTIES FOR MENU MASTER
export const CREATE_MENU_MASTER_REQUEST = 'CREATE_MENU_MASTER_REQUEST';
export const CREATE_MENU_MASTER_SUCCESS = 'CREATE_MENU_MASTER_SUCCESS';
export const CREATE_MENU_MASTER_FAILURE = 'CREATE_MENU_MASTER_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_MENU_MASTER = 'CREATE_USER_FORM_MENU_MASTER';

//GET PROPERTY FROM PROPERTY TABLE
export const MENU_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST = 'MENU_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST';
export const MENU_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS = 'MENU_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS';
export const MENU_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE = 'MENU_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE';

//GET TABLE / VIEW NAME
export const MENU_PROPERTY_TVNAME_FOR_DROPDOWN_REQUEST = 'MENU_PROPERTY_TVNAME_FOR_DROPDOWN_REQUEST';
export const MENU_PROPERTY_TVNAME_FOR_DROPDOWN_SUCCESS = 'MENU_PROPERTY_TVNAME_FOR_DROPDOWN_SUCCESS';
export const MENU_PROPERTY_TVNAME_FOR_DROPDOWN_FAILURE = 'MENU_PROPERTY_TVNAME_FOR_DROPDOWN_FAILURE';

// UPDATE PROPERTIES FOR MENU MASTER
export const UPDATE_MENU_MASTER_REQUEST = 'UPDATE_MENU_MASTER_REQUEST';
export const UPDATE_MENU_MASTER_SUCCESS = 'UPDATE_MENU_MASTER_SUCCESS';
export const UPDATE_MENU_MASTER_FAILURE = 'UPDATE_MENU_MASTER_FAILURE';

// FETCH SINGLE MENU
export const FETCH_SINGLE_MENU_MASTER_REQUEST = 'FETCH_SINGLE_MENU_MASTER_REQUEST';
export const FETCH_SINGLE_MENU_MASTER_SUCCESS = 'FETCH_SINGLE_MENU_MASTER_SUCCESS';
export const FETCH_SINGLE_MENU_MASTER_FAILURE = 'FETCH_SINGLE_MENU_MASTER_FAILURE';

// DELETE PROPERTIES FOR MENU MASTER
export const DELETE_MENU_MASTER_REQUEST = 'DELETE_MENU_MASTER_REQUEST';
export const DELETE_MENU_MASTER_SUCCESS = 'DELETE_MENU_MASTER_SUCCESS';
export const DELETE_MENU_MASTER_FAILURE = 'DELETE_MENU_MASTER_FAILURE';

// USERFORM RESET

export const MENU_MASTER_USERFORM_RESET = 'MENU_MASTER_USERFORM_RESET';

export const FETCH_MENU_FILTER_REQUEST = 'FETCH_MENU_FILTER_REQUEST';
export const FETCH_MENU_FILTER_SUCCESS = 'FETCH_MENU_FILTER_SUCCESS';
export const FETCH_MENU_FILTER_FAILURE = 'FETCH_MENU_FILTER_FAILURE';

export const FETCH_MENU_FILTERED_REQUEST = 'FETCH_MENU_FILTERED_REQUEST';
export const FETCH_MENU_FILTERED_SUCCESS = 'FETCH_MENU_FILTERED_SUCCESS';
export const FETCH_MENU_FILTERED_FAILURE = 'FETCH_MENU_FILTERED_FAILURE';
